<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-morph`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M44.09 7.913l-40-1.818A2 2 0 002 8.093v31.814a2 2 0 002.09 1.998l40-1.818A2 2 0 0046 38.089V9.91a2 2 0 00-1.91-1.998zM6 37.814V10.186l36 1.636v24.356L6 37.814z"/></svg>
</template>
<script>

export default {
  name: 'IconMorph',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
